import React, { useEffect, useState } from 'react';

function AttComponent(props) {
  console.log('image', props);
  const { detail } = props;
  if (detail.att_verizon == 'ATT') {
    return <img style={{ height: 15 }} alt="test" src="/icons_camera/carrier_logo_att.png" />;
  }
  return <img style={{ height: 15 }} alt="test" src="/icons_camera/carrier_logo_verizon.png" />;
}
export default AttComponent;
